import styled from "styled-components";

const BannerContainer = styled.div`
  max-width: 1180px;
  bottom: 0;
  padding: 24px 16px 8px;
  left: 50%;
  transform: translate(-50%);
  position: fixed;
  overflow: hidden;
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.color.body};
  color: ${({ theme }) => theme.color.text};
  z-index: 101;
  transition: 1.3s all ease-in-out;
`;

const BannerButtonControls = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, 1fr);
  place-items: center;
  margin-top: 32px;
  margin-bottom: 48px;
`;

const BannerHeader = styled.h4`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  width: 100%;
`;

const BannerText = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.02em;
  text-align: left;
  margin-top: 12px;

  & > a {
    color: ${({ theme }) => theme.color.darkPurple};
  }
`;

export { BannerContainer, BannerHeader, BannerText, BannerButtonControls };
